import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  MatCard,
  MatCardHeader,
  MatCardContent,
  MatCardActions,
  MatCardTitle,
} from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { ConfigurationClientService } from '../../../services/client/configuration-client.service';

@Component({
  selector: 'app-chat-card',
  imports: [
    CommonModule,
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardActions,
    MatCardTitle,
    MatButton,
  ],
  templateUrl: './chat-card.component.html',
  styleUrls: ['./chat-card.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('0.3s ease-in', style({ opacity: 1 }))]),
    ]),
  ],
})
export class ChatCardComponent {
  @Input() header = 'No conversations';
  @Input() description = 'Please start a chat';
  @Input() button_label?: string = 'Chat Now';
  @Input() route = '/chat';
  @Input() showLogo?: boolean = true; // Optional show logo
  @Input() logoUrl?: string; // Optional logo URL
  @Input() showActions?: boolean = true; // Optional logo URL

  constructor(private router: Router, private configService: ConfigurationClientService) {
  }

  navigate() {
    this.router.navigate([this.route]);
  }

  ngOnInit() {
    // If logoUrl is not provided, use the default from configuration
    if (!this.logoUrl) {
      this.logoUrl = this.configService.getSetting('general', 'logoUrl');
    }
  }
}
